
import React from "react";
import { BackgroundGradientAnimation } from "@/components/ui/background-gradient-animation";
import { Header } from "@/components/layout/Header";
import { Sidebar } from "@/components/layout/Sidebar";

interface ProgramDetailWrapperProps {
  avatarUrl: string;
  name: string;
  children: React.ReactNode;
}

export const ProgramDetailWrapper = ({ avatarUrl, name, children }: ProgramDetailWrapperProps) => {
  return (
    <div className="w-full h-screen overflow-hidden">
      <BackgroundGradientAnimation>
        <div className="flex flex-col w-full h-screen overflow-hidden">
          <Header 
            avatar={avatarUrl} 
            name={name}
            variant="purple" 
          />
          <div className="flex flex-1 w-full overflow-hidden">
            <Sidebar />
            <div className="flex-1 overflow-y-auto w-full">
              {children}
            </div>
          </div>
        </div>
      </BackgroundGradientAnimation>
    </div>
  );
};
